import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { listCitiesOptions } from '../../../features/cities/queries';
import { MeetingTemplateForm } from '../../../features/meeting-templates/components/meeting-template-form';
import { PageHeader } from '../../../shared/components/page-header';

export const Route = createFileRoute('/_authenticated/meeting-templates/new')({
  staticData: { breadcrumb: 'Новый' },
  loader: ({ context }) => context.queryClient.ensureQueryData(listCitiesOptions()),
  component: NewMeetingTemplatePage,
});

function NewMeetingTemplatePage() {
  const { data: cities } = useSuspenseQuery(listCitiesOptions());
  return (
    <div>
      <PageHeader title="Новый шаблон" />
      <MeetingTemplateForm mode="create" cities={cities} />
    </div>
  );
}
